import React from 'react';
import {useMediaPlayer} from '../../../hooks/useMediaPlayer';
import {useAppDispatch, useAppSelector} from '../../../store/hooks';
import {cancel} from '../../../store/slices/upload';
import {ProjectParams, FolderParams} from '../../../types/nav';
import EditorBanner from '../../editor/banner/editorbanner';
import EncoderBanner from '../../encoder/encoderbanner';
import FileUpload from '../banners/fileupload';
import MediaBanner from '../banners/mediabanner';
import {RenderStatusBanner} from '../banners/renderstatus';
import {useWindowDimensions, View} from 'react-native';
import {ChooseDialog} from '../banners/choosedialog';
import {ToastDialog} from '../banners/toastdialog';

export function BannerContainer({
  userId,
  isEncoderProject,
  width,
}: {
  userId: string | undefined;
  isEncoderProject: boolean;
  width: number;
}) {
  const params = useAppSelector(state => state.ui.params);
  const folderType = useAppSelector(state => state.ui.folderType);
  const routeName = useAppSelector(state => state.ui.currentPage);
  const projectId = (params as ProjectParams)?.projectId;
  const folderId = (params as FolderParams)?.folderId;
  const parentFolderId = (params as ProjectParams)?.parentFolderId;
  const dispatch = useAppDispatch();

  const mediaModalVisible = useAppSelector(
    state => state.upload.modalVisible,
  );
  const hideMedialModal = () => {
    dispatch(cancel());
  };

  const mediaPlayer = useMediaPlayer();
  const {height} = useWindowDimensions();
  console.info('bannercontainer reload');
  return (
    <View style={{padding: 0, margin: 0, width}}>
      {mediaModalVisible ? (
        <FileUpload
          projectId={projectId}
          userId={userId}
          folderType={folderType}
          hideMedialModal={hideMedialModal}
          folderId={folderId || parentFolderId}
          routeName={routeName}
          isEncoderProject={isEncoderProject}
        />
      ) : null}
      {mediaPlayer.currentMediaId !== undefined ? (
        <MediaBanner height={height} mediaPlayer={mediaPlayer} />
      ) : null}
      {routeName === 'EncoderProject' ? (
        <EncoderBanner
          projectId={projectId}
          height={height}
          folderId={folderId || parentFolderId}
        />
      ) : null}
      <RenderStatusBanner />
      <ChooseDialog />
      <ToastDialog />
    </View>
  );
}
